import baseURL from "../common/axios";
class Commonservices {
  insert(objinsert) {
    debugger;
    return baseURL.httpMSInventoryUrl.post("ManufactureMAS/Create", objinsert);
  }
  getdata() {
    debugger;
    return baseURL.httpMSInventoryUrl.get("ManufactureMAS/List");
  }
  Edit(EditID) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "ManufactureMAS/Get?id=" + EditID + ""
    );
  }
  Delete(DelID) {
    debugger;
    return baseURL.httpMSInventoryUrl.delete(
      "ManufactureMAS/Delete?id=" + DelID
    );
  }
  //Active
  active(DelID, Status) {
    debugger;
    return baseURL.httpMSInventoryUrl.put(
      "ManufactureMAS/Active?id=" + DelID + "&Status=" + Status + ""
    );
  }
  Update(objupdate) {
    debugger;
    return baseURL.httpMSInventoryUrl.post("ManufactureMAS/Update", objupdate);
  }

  //FileInsert
  Fileinsert(objinsert) {
    debugger;
    return baseURL.httpMSInventoryUrl.post(
      "ManufactureImagesMAS/Create",
      objinsert
    );
  }
  DeleteList(Id) {
    return baseURL.httpMSInventoryUrl.delete("ManufactureImagesMAS/DeleteList?id=" + Id)
  }
  //Get Files by Manufacture Id
  GetFilesByManufactureId(ManufactureId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "ManufactureImagesMAS/ListManufactureImagesMASByManufactureMASId?ManufactureId=" +
      ManufactureId +
      ""
    );
  }
}
export default new Commonservices();
